import React from 'react';
import styled from 'styled-components';
import { Box, BoxProps } from '@material-ui/core';

export const HoverableBox = styled(({ isDisabled, ...props }: BoxProps & { isDisabled?: boolean }) => <Box {...props} />)`
    &:hover {
        cursor: ${({ isDisabled }) => isDisabled ? `not-allowed` : `pointer`};
    }

`;